(function () {
  function getThemeUri() {
    if (window.madThemeData && window.madThemeData.themeUri) {
      return window.madThemeData.themeUri.replace(/\/+$/, '');
    }

    const script = document.querySelector('script[src*="/assets/dist/js/main.min.js"]');
    if (script) {
      return script.getAttribute('src').split('/assets/dist/js/')[0];
    }

    return '';
  }

  window.madPlyrIconUrl = getThemeUri() + '/assets/img/plyr.svg';
})();
